export const Sizes = {
  SidebarWidth: '16rem',
  HeaderHeight: '4rem'
};
